import {
  DraftSpecialTextConfiguration,
  DraftState,
  DraftTextConfiguration,
  StoreFont,
} from '@/types';
import { isBrightColor } from '@/utils/colors/isBrightColor';
import { getTextSize } from '@/utils/text/getTextSize';
import { getCurrentSizeOfConfiguration } from '@/model/configuration/getCurrentSizeOfConfiguration';
import { getAppearance } from '@/model/draft/getAppearance';
import { convertColors } from '@/model/printType/convertColors';
import { getTextStyleForWidth } from './helper/getTextStyleForWidth';
import { updateSizeAndOffset } from './helper/updateSizeAndOffset';

export const convertSpecialTextToTextAction =
  (configuration: DraftSpecialTextConfiguration, font: StoreFont) => (draft: DraftState) => {
    const currentSize = getCurrentSizeOfConfiguration(configuration);
    const printType = configuration.printType;
    const currentText = configuration.text;
    const textContent = currentText.content;
    const textAlign = currentText.style.textAlign;

    const newText = {
      content: textContent,
      style: getTextStyleForWidth(
        textContent,
        currentSize.width,
        font,
        printType,
        textAlign === 'justify' ? undefined : textAlign
      ),
    };

    const draftTextConfiguration: DraftTextConfiguration = {
      ...configuration,
      type: 'text',
      text: newText,
    };

    updateSizeAndOffset(draftTextConfiguration, getTextSize(newText), 1);

    // keep existing print color if we came from a text config but add it
    // if we don't have on yet (aka we have an existing product)
    if (!draftTextConfiguration.printColors || !draftTextConfiguration.printColors.length) {
      draftTextConfiguration.printColors = convertColors(printType, [
        { fill: isBrightColor(getAppearance(draft).colors[0].value) ? '#000000' : '#FFFFFF' },
      ]);
    }

    draft.configurations[draftTextConfiguration.cid] = draftTextConfiguration;
  };
